/* components/LoadMore */

import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class LoadMore extends ThemeComponent {

}
